import React from 'react'
import { withRouteData, Head } from 'react-static'
import compileMarkdown from 'lib/compileMarkdown'
import {
  Link,
  A,
  Flex,
  Box,
  Text,
  Icon,
  HeadingWithAnchor as Heading,
  Container,
  PostsList,
  ProjectList,
  BlurbSection,
  AvatarImage
} from 'components'

const socialLinkStyle = {
  display: 'inline-block',
  whiteSpace: 'nowrap'
}

export default withRouteData(({
  blurb, posts, image, whereToFindMe, projects
}) => (
  <Container maxWidth="medium">
    <Head>
      <title>Will Hoag - Home</title>
      <meta name="description" content="Website for the developer, entrepreneur, and indiehacker, Will Hoag" />
    </Head>
    <Flex flexWrap="wrap" mb={[5, 0]}>
      <Box my={['7vh', '8vh']} w={[1, 1/3]}>
        <AvatarImage mx="auto" src={image} alt="profile image" />
      </Box>
      <Flex w={[1, 2/3]} alignItems="center">
        <Text textAlign={['center', 'left']}>
          {compileMarkdown(blurb).tree}
          <div>
            <A style={socialLinkStyle} mx={[3, 0]} mt={2} href="https://twitter.com/devhoag" target="_blank">
              <Icon style={{ verticalAlign: 'middle' }} size={24} role="image" name="twitter" /> @devhoag
            </A>
            <A style={socialLinkStyle} mx={3} mt={2} href="mailto:dev@willhoag.com" target="_blank">
              <Icon style={{ verticalAlign: 'middle' }} size={24} role="image" name="mail" /> dev@willhoag.com
            </A>
          </div>
        </Text>
      </Flex>
    </Flex>
    <Box mb={[5]}>
      <Heading is="h2" id="latest-projects">
        Latest Projects
      </Heading>
      <ProjectList list={projects.filter(project => project.featured)} />
    </Box>
    <Box mb={[5]}>
      <Heading is="h2" id="recent-writing">
        Recent Writing
      </Heading>
      <PostsList posts={posts.slice(0, 3)} />
      <Link to="/writing">More...</Link>
    </Box>
    {/* <BlurbSection mt={[4, 5]} blurb={whereToFindMe} /> */}
  </Container>
))



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Home.js